import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';

export interface HttpRequestOptions {
  params?: HttpParams;
  endpoint?: string; // Para segmentos de ruta adicionales (ej. /lotes/resumen)
  headers?: HttpHeaders;
  trackLoading?: boolean; // <--- NUEVO: opt-in para el loading global
}

@Injectable({ providedIn: 'root' })
export class LoteDetalleUrlService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'lotes'); // base: /lotes
  }

  addDocumentToLote(
    loteId: number,
    body: any,
    trackLoading: boolean = true
  ): Observable<any> {
    return this.post<any>(
      body,
      `${loteId}/detalles/urls`,
      undefined,
      trackLoading // 👈 activa el loader
    );
  }

  indexDetalleUrl<T>(
    loteId: number,
    options?: HttpRequestOptions,
    trackLoading: boolean = true
  ): Observable<HttpResponse<T>> {
    return this.get<T>({
      params: options?.params,
      headers: options?.headers,
      endpoint: `${loteId}/detalles/urls`,
      trackLoading,
    });
  }

  loteDetalleGrupo(id_lote: number, params: any): Observable<any> {
    return this.get<any>({ endpoint: `${id_lote}/detalles`, params });
  }

  indexDetalleUrlGrupo(
    loteId: number,
    loginId: number,
    options?: HttpRequestOptions,
    trackLoading: boolean = true
  ): Observable<any> {
    return this.get<any>({
      params: options?.params,
      headers: options?.headers,
      endpoint: `${loteId}/detalles/urls/${loginId}/detalles`,
      trackLoading, // 👈 activa el loader
    });
  }

  deleteDetalleUrl(
    loteId: number,
    loteDetalleUrlId: number,
    trackLoading: boolean = true
  ): Observable<any> {
    return this.delete<any>(
      `${loteId}/detalles/urls/${loteDetalleUrlId}`,
      undefined,
      undefined,
      trackLoading // 👈 activa el loader
    );
  }

  showDetalleUrl(
    loteId: number,
    loteDetalleUrlId: number,
    trackLoading: boolean = true
  ): Observable<any> {
    return this.get<any>({
      endpoint: `${loteId}/detalles/urls/${loteDetalleUrlId}`,
      trackLoading, // 👈 activa el loader
    });
  }

  findAllCoordenadas(
    loteId: number,
    trackLoading: boolean = true
  ): Observable<any> {
    return this.get<any>({
      endpoint: `${loteId}/detalles/urls/coordenadas`,
      trackLoading, // 👈 activa el loader
    });
  }
}
